export function getUniqueID(){
	return window.navigator.userAgent
}

export function getUserAgent(){
	return window.navigator.userAgent
}



// WEBPACK FOOTER //
// ./client/shim/deviceInfo.js